<div class="modal" [class.modal-show]="isModalShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <div class="modal-icon">
    <span>!</span>
  </div>

  <h2>Не вибрано жодної позиції</h2>

  <p class="modal-text">
    Для продовження оформлення замовлення необхідно обрати хоча б один товар.
  </p>

  <div class="modal-actions">
    <a class="button modal-btn" (click)="closeModal()">Зрозуміло</a>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
